import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { translate } from '../services';
export class Image extends Component {
  setImageSize = e => {
    if( this.props.isIE ) {
      const image = e.target;
      // image.style.height = image.naturalHeight >= image.naturalWidth ? '100%' : 'auto';
      // image.style.width = image.naturalHeight >= image.naturalWidth ? 'auto' : '100%';
      image.style.height =  'auto';
      image.style.width =  'auto';
    }
  }

  onClick = () => {
    this.props.onClick && this.props.onClick();
  }
  
  render() {
    const { alt, className, source, title, onError } = this.props;
    return <img 
      className={ className || '' } 
      onLoad={ this.setImageSize } 
      src={ source } 
      alt={ alt } 
      onClick={ this.onClick }
      title={ translate( title )}
      style={this.props.style}
      onError={onError&&onError}
    
    />;
  }
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  isIE: PropTypes.bool,
  onClick: PropTypes.func,
  source: PropTypes.string.isRequired
};